<template>
  <div style="text-wrap: nowrap" class="tw-text-xs">
    <div
      class="tw-space-x-4"
      :class="[
        Classes.TILE_MOD_STATS,
        { 'tw-flex tw-justify-between tw-w-full': !dependency },
      ]"
    >
      <div v-if="!dependency" class="tw-justify-start tw-w-fit tw-max-w-1/3">
        <tooltip-hover :text="t('filesize')">
          <item-card-footer-stat
            :label="t('filesize')"
            icon="database"
            :text="humanFilesize(modfile?.filesize || 0)"
          />
        </tooltip-hover>
      </div>

      <div
        class="tw-justify-end tw-flex"
        :class="
          dependency ? 'tw-w-full' : 'tw-w-1/3  tw-space-x-2 md:tw-space-x-1'
        "
      >
        <tooltip-hover
          v-if="dependency"
          class="tw-flex tw-justify-end tw-flex-1"
          :text="t('filesize')"
        >
          <item-card-footer-stat
            :label="t('filesize')"
            icon="database"
            :text="humanFilesize(modfile?.filesize || 0)"
          />
        </tooltip-hover>

        <tooltip-hover
          class="tw-flex tw-justify-end tw-flex-1"
          :class="{ 'tw-ml-3': dependency }"
          :text="t('downloads')"
        >
          <item-card-footer-stat
            :label="t('downloads')"
            icon="download"
            :text="numberFormatter(stats?.downloads_total || 0)"
          />
        </tooltip-hover>

        <tooltip-hover
          class="tw-flex tw-flex-1 tw-justify-end"
          :class="{ 'tw-ml-3': dependency }"
          :text="otherStat.label"
        >
          <item-card-footer-stat
            :label="otherStat.label"
            :icon="otherStat.icon"
            :text="otherStat.value"
          />
        </tooltip-hover>
      </div>
    </div>
  </div>
</template>

<script>
import ItemCardFooterStat from '@components/List/ItemCardFooterStat.vue'
import { numberFormatter, humanFilesize } from '@helpers/utils.js'
import TooltipHover from '@components/Message/TooltipHover.vue'
import Classes from '@shared/js/config/css.js'
import { useSort } from '@composables'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
export default {
  components: {
    ItemCardFooterStat,
    TooltipHover,
  },
  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
    modfile: {
      type: Object,
      default: () => ({}),
    },
    dateAdded: {
      type: Number,
      default: 0,
    },
    dateUpdated: {
      type: Number,
      default: 0,
    },
    browseId: {
      type: String,
      required: true,
    },
    dependency: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { sort } = useSort(props.browseId)
    const { t } = useI18n()

    const otherStat = computed(() => {
      switch (sort.value?.sortBy) {
        case 'subscribers':
          return {
            label: t('subscribers'),
            value: numberFormatter(props.stats?.subscribers_total || 0),
            icon: 'star',
          }

        default:
          return {
            label: t('thumbs_up'),
            value: numberFormatter(props.stats?.ratings_positive || 0),
            icon: 'thumbs-up',
          }
      }
    })

    return {
      numberFormatter,
      humanFilesize,
      otherStat,
      Classes,
      t,
    }
  },
}
</script>
